import {emptyValue} from "./global";
import validateVar from "./validation/validateVariable";

function get_customer_company_name(company, first_name, last_name){
    if(validateVar(company)) return company;
    else if(validateVar(first_name) && validateVar(last_name)) return first_name + ' ' + last_name;
    else return emptyValue;
}

export default get_customer_company_name;